<template>
    <div>
      系统更新
    </div>
</template>

<script>
  export default {
    name: 'SystemUpdate'
  }
</script>

<style scoped>

</style>
